import unitedKingdomFlag from "assets/icons/united-kingdom-flag.svg";
import vietnamFlag from "assets/icons/vietnam-flag.svg";

export enum LanguageID {
  vi = "vi",
  uk = "en",
}

export const AppLanguages = [
  { id: LanguageID.uk, flagIcon: unitedKingdomFlag, name: "English" },
  { id: LanguageID.vi, flagIcon: vietnamFlag, name: "Việt Nam" },
];

export const DefaultLanguage = LanguageID.uk as const;
